import React from "react";
import { Checkbox, FormControlLabel, FormHelperText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "../styles/CustomCheckbox.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  label: {
    fontSize: 14,
    color: "#000E3D",
    fontFamily: "Inter",
    fontWeight: 500,
  },
  checkbox: {
    color: "#4a90e2",
    "&.Mui-checked": {
      color: "#4a90e2",
    },
  },
  error: {
    color: theme.palette.error.main,
    marginTop: -5,
    marginLeft: 32,
  },
}));

const CustomCheckbox = ({
  label,
  fieldKey,
  checked,
  onChange,
  disabled = false,
  error = null,
  helperText = null,
  color = "primary",
}) => {
  const classes = useStyles();

  const handleChange = (event) => {
    onChange({
      target: {
        key: fieldKey,
        value: event.target.checked,
      },
    });
  };

  return (
    <div className={`custom-checkbox-container ${error ? "has-error" : ""}`}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={handleChange}
            name={fieldKey}
            color={color}
            disabled={disabled}
            className={classes.checkbox}
          />
        }
        label={label}
        className={classes.root}
        classes={{ label: classes.label }}
      />
      {(error || helperText) && (
        <FormHelperText className={error ? classes.error : ""}>
          {error || helperText}
        </FormHelperText>
      )}
    </div>
  );
};

export default CustomCheckbox;
